/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BidManagementEditOrderUnitRequest } from './BidManagementEditOrderUnitRequest';

export type BidManagementEditOrderRequest = {
    id: number;
    invoiceMemberAddressid?: number;
    invoiceName?: string;
    invoiceZip?: string;
    invoiceAddress1?: string;
    invoiceAddress2?: string;
    invoiceAddress3?: string | null;
    invoiceTel?: string;
    destinationMemberAddressid?: number;
    destinationName?: string;
    destinationZip?: string;
    destinationAddress1?: string;
    destinationAddress2?: string;
    destinationAddress3?: string | null;
    destinationTel?: string;
    orderUnits?: Array<BidManagementEditOrderUnitRequest>;
    usePoint?: number;
    paymentType: BidManagementEditOrderRequest.paymentType;
    paymentLimitDate?: string | null;
    deliveryPreferredDate?: string | null;
    deliveryPreferredTime?: number | null;
    note?: string | null;
    status?: BidManagementEditOrderRequest.status;
    noteStaff?: string | null;
};

export namespace BidManagementEditOrderRequest {

    export enum paymentType {
        BANK = 'Bank',
        C_O_D = 'C.O.D',
        DIRECT = 'Direct',
    }

    export enum status {
        INITIAL = 'initial',
        RESERVED = 'reserved',
        CONFIRMED = 'confirmed',
        PACKING = 'packing',
        STOCK = 'stock',
        SENTED = 'sented',
        CANCEL = 'cancel',
    }


}

